module.exports = __webpack_public_path__ + "static/img/es.0b8bbb65.png";